import React, { useState, useEffect } from "react";
import "../../Styles/Filter.css";
import {
  filterApi,
  menuSlugSection,
} from "../../Services/Operations/ProductAPI";
import { FaFilter, FaAngleUp, FaAngleDown, FaTimes } from "react-icons/fa";

function MenFilter({ menu, categoryName, setProductData, productData }) {
 const [selectedCategory, setSelectedCategory] = useState(categoryName || "");
  const [selectedSubcategory, setSelectedSubcategory] = useState("");
  const [selectedColors, setSelectedColors] = useState([]);
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(true);
  const [showSortDropdown, setShowSortDropdown] = useState(true);
  const [showSubcategoryDropdown, setShowSubcategoryDropdown] = useState(true);
  const [showColorDropdown, setShowColorDropdown] = useState(true);
  const [showPriceRange, setShowPriceRange] = useState(true);
  const [menuSlug, setMenuSlug] = useState([]);
  const [filteredSubcategories, setFilteredSubcategories] = useState([]);
  const [availableColors, setAvailableColors] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [allProducts, setAllProducts] = useState([]);

  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);

  const toggleMobileFilter = () => {
    setIsMobileFilterOpen(!isMobileFilterOpen);
  };

  useEffect(() => {
    if (isMobileFilterOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobileFilterOpen]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const formData = new FormData();
        formData.append("slug", menu);
        const response = await menuSlugSection(formData);
        console.log("API response for MenFilter:", response.data.category);
        if (response.success === true) {
          setMenuSlug(response.data.category);
          if (categoryName) {
            const matchedCategory = response.data.category.find(
              (category) => category.slug === categoryName
            );
            if (matchedCategory) {
              setSelectedCategory(matchedCategory.name);
              setFilteredSubcategories(matchedCategory.subcategory);
            }
          }
        }
      } catch (error) {
        console.error("Error during API call:", error);
      }
    };

    fetchCategories();
  }, [menu, categoryName]);

  useEffect(() => {
    const matchedCategory = menuSlug.find(
      (category) => category.name === selectedCategory
    );
    setFilteredSubcategories(
      matchedCategory ? matchedCategory.subcategory : []
    );
  }, [selectedCategory, menuSlug]);

  // Extract unique colors from all products
  const extractColorsFromProducts = (products) => {
    const colorMap = new Map();
    
    products.forEach(product => {
      if (product.color && Array.isArray(product.color)) {
        product.color.forEach(color => {
          if (color.color_id && color.name && color.code) {
            colorMap.set(color.color_id, {
              id: color.color_id,
              name: color.name,
              code: color.code
            });
          }
        });
      }
    });

    return Array.from(colorMap.values());
  };

  // Update available colors when products change
  useEffect(() => {
    if (productData && productData.length > 0) {
      setAllProducts(productData);
      const colors = extractColorsFromProducts(productData);
      setAvailableColors(colors);
    }
  }, [productData]);

  const handleColorSelection = (colorId) => {
    setSelectedColors(prev => {
      if (prev.includes(colorId)) {
        return prev.filter(id => id !== colorId);
      } else {
        return [...prev, colorId];
      }
    });
  };

  const applyFilter = async () => {
    try {
      const categoryObj = menuSlug.find((cat) => cat.name === selectedCategory);
      const categorySlug = categoryObj?.slug || categoryName;

      let filter = "";
      if (selectedOption === "NewestFirst") filter = "new_first";
      else if (selectedOption === "OldFirst") filter = "old_first";
      else if (selectedOption === "lowToHigh") filter = "price_low_to_high";
      else if (selectedOption === "highToLow") filter = "price_high_to_low";

      // If no filters are selected (except maybe sorting), get fresh data from API
      if (
        selectedColors.length === 0 &&
        !selectedSubcategory &&
        !minPrice &&
        !maxPrice
      ) {
        const products = await filterApi(menu, categorySlug, filter);
        setAllProducts(products.data);
        setProductData(products.data);
        return;
      }

      // Otherwise, filter the existing products
      let filteredProducts = [...allProducts];
      
      // Apply sorting first
      if (filter === "new_first") {
        filteredProducts.sort((a, b) => b.id - a.id);
      } else if (filter === "old_first") {
        filteredProducts.sort((a, b) => a.id - b.id);
      } else if (filter === "price_low_to_high") {
        filteredProducts.sort((a, b) => (a.price || 0) - (b.price || 0));
      } else if (filter === "price_high_to_low") {
        filteredProducts.sort((a, b) => (b.price || 0) - (a.price || 0));
      }
      
      // Apply color filtering if colors are selected
      if (selectedColors.length > 0) {
        filteredProducts = filteredProducts.filter(product => {
          if (!product.color || !Array.isArray(product.color)) return false;
          return product.color.some(color => 
            selectedColors.includes(color.color_id)
          );
        });
      }
      
      // Apply subcategory filtering if subcategory is selected
      if (selectedSubcategory) {
        filteredProducts = filteredProducts.filter(product => 
          product.subcategory_name === selectedSubcategory
        );
      }
      
      // Apply price range filtering
      if (minPrice || maxPrice) {
        filteredProducts = filteredProducts.filter(product => {
          const productPrice = product.price || product.mrp || 0;
          const min = minPrice ? parseFloat(minPrice) : 0;
          const max = maxPrice ? parseFloat(maxPrice) : Infinity;
          return productPrice >= min && productPrice <= max;
        });
      }
      
      setProductData(filteredProducts);
    } catch (error) {
      console.error("Error fetching filtered products:", error);
    }
  };

  const clearAllFilters = async() => {
    setSelectedCategory(categoryName || "");
    setSelectedSubcategory("");
    setSelectedColors([]);
    setMinPrice("");
    setMaxPrice("");
    setSelectedOption("");
    // Reset to original products
      const categoryObj = menuSlug.find((cat) => cat.name === selectedCategory);
      const categorySlug = categoryObj?.slug || categoryName;

      let filter = "";



     const products = await filterApi(menu, categorySlug, filter);
        setAllProducts(products.data);
        setProductData(products.data);
        return;


  
  };

  const handleToggleDropdown = () => {
    setShowSortDropdown((prev) => !prev);
  };

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
    setShowSortDropdown(false);
  };

  return (
   
   
    <div style={{width:"85%",paddingRight:"10px",maxHeight:"100%"}}>

       <div className="mobile-filter-button-container" style={{bottom:"20px",position:"fixed",zIndex:400,right:"20px"}}>
        <button className="mobile-filter-button" onClick={toggleMobileFilter}>
          <FaFilter className="filter-icon" />
          <span style={{marginLeft:"13px"}}>Filters</span>
        </button>
      </div>
    
      <div className="filter-section">
        <div className="filter-container">
          <div 
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px',paddingBottom:"10px",borderBottom:"1px solid gray" }}>
            <p className="filter-title large1" style={{ fontSize: "20px", margin: 0,fontWeight:700,color:"black" }}>
              Filters
            </p>
           
          </div>

          <div className="category-section" style={{borderBottom:"1px solid gray",width:"80%"}}>
            <div
              className="dropdown-header"
              onClick={() => setShowCategoryDropdown(!showCategoryDropdown)}
            >
              <p className="" style={{ fontSize: "18px",fontWeight:700 }}>
                Categories
              </p>
              {showCategoryDropdown ? <FaAngleUp /> : <FaAngleDown />}
            </div>
            {showCategoryDropdown && (
              <div className="" style={{display:"flex",flexDirection:"column"}}>
                {menuSlug.map((category) => (
                  <div
                    key={category.id}
                   
                    onClick={() => {
                      setSelectedCategory(category.name);
                      setSelectedSubcategory("");
                    }}
                    style={{ fontSize: "14px" ,display:"flex",alignItems:"start",gap:"14px"}}
                  >
                    <div style={{width:"20px",height:"20px",border:"1px solid gray",borderRadius:"5px",backgroundColor:selectedCategory === category.name?"gray":"white"}}></div>
                    <p style={{fontSize:"15px",fontWeight:300,}}>{category.name}</p>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* SUBCATEGORY */}
          <div className="subcategory-section" style={{borderBottom:"1px solid gray",width:"80%"}}>
            <div
              className="dropdown-header"
              onClick={() =>
                setShowSubcategoryDropdown(!showSubcategoryDropdown)
              }
            >
              <p className=" " style={{ fontSize: "18px",fontWeight:700 }}>
                Subcategories
              </p>
              {showSubcategoryDropdown ? <FaAngleUp /> : <FaAngleDown />}
            </div>
            {showSubcategoryDropdown && (
              <div className="" style={{display:"flex",flexDirection:'column'}}>
                {filteredSubcategories.map((subcategory) => (
                  <div
                    key={subcategory.id}
                    
                    onClick={() => setSelectedSubcategory(subcategory.name)}
                    style={{ fontSize: "14px" ,display:"flex", alignItems:"start",gap:"15px"}}
                  >
                     <div style={{width:"20px",height:"20px",border:"1px solid gray",borderRadius:"5px",backgroundColor:selectedSubcategory === subcategory.name?"gray":"white"}}></div>
                   
                    <p style={{fontSize:"15px",fontWeight:300}}>{subcategory.name}</p>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* COLOR SECTION */}
         {/* COLOR SECTION */}
<div className="color-section" style={{width:"80%"}}>
  <div
    className="dropdown-header"
    onClick={() => setShowColorDropdown(!showColorDropdown)}
  >
    <p className="" style={{ fontSize: "18px",fontWeight:700 }}>
      COLOR
    </p>
    {showColorDropdown ? <FaAngleUp /> : <FaAngleDown />}
  </div>
  {showColorDropdown && (
    <div className="color-grid-container" style={{maxWidth:"70%"}}>
      {availableColors.map((color) => (
        <div
          key={color.id}
          className={`color-option1  ${selectedColors.includes(color.id) ? "selected" : ""}`}
          onClick={() => handleColorSelection(color.id)}
          title={color.name}
        >
          <div className="color-swatch-container">
            <div
              className="color-swatch"
              style={{ backgroundColor: color.code}}
            />
            <div className="color-checkmark">
              {selectedColors.includes(color.id) && (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M20 6L9 17l-5-5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
            </div>
          </div>
          <span className="color-name">{color.name}</span>
        </div>
      ))}
      {availableColors.length === 0 && (
        <p className="no-colors-message">No colors available</p>
      )}
    </div>
  )}
</div>

          <button
            className="filter-button"
            onClick={applyFilter}
            style={{ fontSize: "18px" ,width:'80%'}}
          >
            Apply Filters
          </button>
        </div>
      </div>

      <div
        className={`mobile-filter-overlay ${isMobileFilterOpen ? "open" : ""}`}
        onClick={toggleMobileFilter}
      ></div>



  {/* for mobile */}
      <div
        className={`mobile-filter-panel ${isMobileFilterOpen ? "open" : ""}`}
        style={{zIndex:10000}}
      >
        <div className="mobile-filter-header">
          <h3>Filters</h3>
          <button className="close-filter-button" onClick={toggleMobileFilter}>
            <FaTimes />
          </button>
        </div>

        <div className="mobile-filter-content" style={{ marginTop: "13px" }}>
      

          <div className="mobile-filter-section">
            <div
              className="mobile-filter-section-header"
              onClick={() => setShowCategoryDropdown(!showCategoryDropdown)}
            >
              <h4>CATEGORY</h4>
              {showCategoryDropdown ? <FaAngleUp /> : <FaAngleDown />}
            </div>
            {showCategoryDropdown && (
              <div className="mobile-filter-options">
                {menuSlug.map((category) => (
                  <button
                    key={category.id}
                    className={`mobile-filter-option ${
                      category.slug === categoryName ? "highlighted" : ""
                    } ${selectedCategory === category.name ? "selected" : ""}`}
                    onClick={() => {
                      setSelectedCategory(category.name);
                      setSelectedSubcategory("");
                    }}
                  >
                    {category.name}
                  </button>
                ))}
              </div>
            )}
          </div>

          <div className="mobile-filter-section">
            <div
              className="mobile-filter-section-header"
              onClick={() =>
                setShowSubcategoryDropdown(!showSubcategoryDropdown)
              }
            >
              <h4>SUBCATEGORY</h4>
              {showSubcategoryDropdown ? <FaAngleUp /> : <FaAngleDown />}
            </div>
            {showSubcategoryDropdown && (
              <div className="mobile-filter-options">
                {filteredSubcategories.map((subcategory) => (
                  <button
                    key={subcategory.id}
                    className={`mobile-filter-option ${
                      selectedSubcategory === subcategory.name ? "selected" : ""
                    }`}
                    onClick={() => setSelectedSubcategory(subcategory.name)}
                  >
                    {subcategory.name}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* MOBILE COLOR SECTION */}
         {/* MOBILE COLOR SECTION */}
<div className="mobile-filter-section">
  <div
    className="mobile-filter-section-header"
    onClick={() => setShowColorDropdown(!showColorDropdown)}
  >
    <h4>COLOR</h4>
    {showColorDropdown ? <FaAngleUp /> : <FaAngleDown />}
  </div>
  {showColorDropdown && (
    <div className="mobile-color-grid">
      {availableColors.map((color) => (
        <div
          key={color.id}
          className={`mobile-color-option1  ${selectedColors.includes(color.id) ? "selected" : ""}`}
          onClick={() => handleColorSelection(color.id)}
          title={color.name}
        >
          <div className="mobile-color-swatch-container">
            <div
              className="mobile-color-swatch"
              style={{ backgroundColor: color.code }}
            />
            <div className="mobile-color-checkmark">
              {selectedColors.includes(color.id) && (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M20 6L9 17l-5-5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
            </div>
          </div>
          <span className="mobile-color-name">{color.name}</span>
        </div>
      ))}
    </div>
  )}
</div>

          <button
            className="mobile-apply-button"
            onClick={() => {
              applyFilter();
              toggleMobileFilter();
            }}
            style={{display:"flex",alignItems:"center",justifyContent:"center",}}
          >
            Apply Filters
          </button>

          <button
            className="mobile-clear-button"
            onClick={() => {
              clearAllFilters();
              toggleMobileFilter();
            }}
               style={{display:"flex",alignItems:"center",justifyContent:"center",}}
          >
            Clear All Filters
          </button>
        </div>
      </div>

      <style jsx>{`
        /* Mobile Filter Button */
        .mobile-filter-button-container {
        
     
        }

        .mobile-filter-button {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 8px 20px;
          background-color: #2c3e50;
          color: white;
          border: none;
          border-radius: 30px;
          font-size: 12px;
          font-weight: 600;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .mobile-filter-button:hover {
          background-color: #34495e;
          transform: translateY(-2px);
        }

        .filter-icon {
          font-size: 18px;
        }

        /* Price inputs styling */
        .price-inputs {
          display: flex;
          gap: 4%;
          margin-top: 10px;
        }

        .mobile-price-inputs {
          display: flex;
          gap: 4%;
          margin-top: 10px;
        }

        /* Color options styling */
        .color-boxes {
          margin-top: 10px;
          max-height: 200px;
          overflow-y: auto;
        }

        .mobile-color-option1 s {
          margin-top: 10px;
          max-height: 200px;
          overflow-y: auto;
        }

        .mobile-color-option1  {
          display: flex;
          align-items: center;
          padding: 8px 12px;
          border: 1px solid #ddd;
          border-radius: 4px;
          cursor: pointer;
          margin-bottom: 5px;
          transition: all 0.2s;
        }

        .mobile-color-option1 :hover {
          background-color: #f0f0f0;
        }

        .mobile-color-option1 .selected {
          background-color: #2c3e50;
          color: white;
          border-color: #2c3e50;
        }

        .mobile-clear-button {
          width: 100%;
          padding: 15px;
          background-color: #e74c3c;
          color: white;
          border: none;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          margin-top: 10px;
          transition: background-color 0.3s;
        }

        .mobile-clear-button:hover {
          background-color: #c0392b;
        }

        /* Mobile Filter Overlay */
        .mobile-filter-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 996;
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s ease;
        }

        .mobile-filter-overlay.open {
          opacity: 1;
          visibility: visible;
        }

        /* Mobile Filter Panel */
        .mobile-filter-panel {
          position: fixed;
          top: 0;
          left: -100%;
          width: 85%;
          max-width: 320px;
          height: 100vh;
          background-color: white;
          z-index: 997;
          overflow-y: auto;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 2px 0 15px rgba(0, 0, 0, 0.1);
        }

        .mobile-filter-panel.open {
          left: 0;
        }

        .mobile-filter-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px;
          border-bottom: 1px solid #eee;
        }

        .mobile-filter-header h3 {
          margin: 0;
          font-size: 20px;
          color: #333;
        }

        .close-filter-button {
          background: none;
          border: none;
          font-size: 20px;
          color: #666;
          cursor: pointer;
          transition: color 0.2s;
        }

        .close-filter-button:hover {
          color: #333;
        }

        .mobile-filter-content {
          padding: 0 20px 20px;
        }

        .mobile-filter-section {
          margin-bottom: 20px;
          border-bottom: 1px solid #f0f0f0;
          padding-bottom: 15px;
        }

        .mobile-filter-section-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px 0;
          cursor: pointer;
        }

        .mobile-filter-section-header h4 {
          margin: 0;
          font-size: 16px;
          color: #333;
          font-weight: 600;
        }

        .mobile-filter-dropdown {
          margin-top: 10px;
        }

        .mobile-custom-select {
          width: 100%;
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 14px;
          background-color: #f9f9f9;
        }

        .mobile-filter-options {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 10px;
        }

        .mobile-filter-option {
          padding: 8px 12px;
          background-color: #f5f5f5;
          border: none;
          border-radius: 4px;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.2s;
        }

        .mobile-filter-option:hover {
          background-color: #e0e0e0;
        }

        .mobile-filter-option.selected {
          background-color: #2c3e50;
          color: white;
        }

        .mobile-filter-option.highlighted {
          border: 1px solid #2c3e50;
        }

        .mobile-apply-button {
          width: 100%;
          padding: 15px;
          background-color: #2c3e50;
          color: white;
          border: none;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          margin-top: 20px;
          transition: background-color 0.3s;
        }

        .mobile-apply-button:hover {
          background-color: #34495e;
        }

        @media (max-width: 768px) {
          .mobile-filter-button-container {
            display: block;
          }
          .main-content {
            margin-top: 58px;
          }
        }
        @media (min-width: 768px) {
          .mobile-filter-button-container {
            display: none;
          }
        }
      `}</style>
      <style jsx>{`
  /* Modern Color Filter Styles */
  .color-grid-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    margin-top: 12px;
  }

  .color-option1  {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .color-option1 :hover {
    transform: translateY(-2px);
  }

  .color-swatch-container {
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-bottom: 6px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    transition: all 0.2s ease;
  }

  .color-swatch {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px solid white;
    box-sizing: border-box;
  }

  .color-checkmark {
    position: absolute;
    top: -4px;
    right: -4px;
    width: 18px;
    height: 18px;
    background-color: #2c3e50;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transform: scale(0.8);
    transition: all 0.2s ease;
  }

  .color-checkmark svg {
    width: 10px;
    height: 10px;
    color: white;
  }

  .color-option1 .selected .color-checkmark {
    opacity: 1;
    transform: scale(1);
  }

  .color-option1 .selected .color-swatch-container {
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
  }

  .color-name {
    font-size: 12px;
    color: #333;
    text-align: center;
    max-width: 60px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Mobile Color Grid */
  .mobile-color-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-top: 10px;
  }

  .mobile-color-option1  {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px;
    border-radius: 8px;
    background-color: #f8f8f8;
  }

  .mobile-color-option1 .selected {
    background-color: #e8f0fe;
    border: 1px solid #2c3e50;
  }

  .mobile-color-swatch-container {
    position: relative;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-bottom: 4px;
  }

  .mobile-color-swatch {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px solid white;
  }

  .mobile-color-checkmark {
    position: absolute;
    top: -4px;
    right: -4px;
    width: 16px;
    height: 16px;
    background-color: #2c3e50;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mobile-color-checkmark svg {
    width: 8px;
    height: 8px;
    color: white;
  }

  .mobile-color-name {
    font-size: 11px;
    color: #333;
    text-align: center;
  }

  .no-colors-message {
    grid-column: 1 / -1;
    text-align: center;
    font-size: 14px;
    color: #666;
    font-style: italic;
    padding: 10px 0;
  }
`}</style>
    </div>
  
   
    
  );
}

export default MenFilter;

// import React, { useState, useEffect } from "react";
// import "../../Styles/Filter.css";
// import {
//   filterApi,
//   menuSlugSection,
// } from "../../Services/Operations/ProductAPI";
// import { FaFilter, FaAngleUp, FaAngleDown, FaTimes } from "react-icons/fa";

// function MenFilter({ menu, categoryName, setProductData }) {
//   const [selectedCategory, setSelectedCategory] = useState(categoryName || "");
//   const [selectedSubcategory, setSelectedSubcategory] = useState("");
//   const [minPrice, setMinPrice] = useState("");
//   const [maxPrice, setMaxPrice] = useState("");
//   const [showCategoryDropdown, setShowCategoryDropdown] = useState(true);
//   const [showSortDropdown, setShowSortDropdown] = useState(true);
//   const [showSubcategoryDropdown, setShowSubcategoryDropdown] = useState(true);
//   const [showPriceRange, setShowPriceRange] = useState(true);
//   const [menuSlug, setMenuSlug] = useState([]);
//   const [filteredSubcategories, setFilteredSubcategories] = useState([]);
//   const [selectedOption, setSelectedOption] = useState("");

//   const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);

//   const toggleMobileFilter = () => {
//     setIsMobileFilterOpen(!isMobileFilterOpen);
//   };

//   useEffect(() => {
//     if (isMobileFilterOpen) {
//       document.body.style.overflow = "hidden";
//     } else {
//       document.body.style.overflow = "auto";
//     }

//     return () => {
//       document.body.style.overflow = "auto";
//     };
//   }, [isMobileFilterOpen]);

//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         const formData = new FormData();
//         formData.append("slug", menu);
//         const response = await menuSlugSection(formData);
//         console.log("API response for MenFilter:", response.data.category);
//         if (response.success === true) {
//           setMenuSlug(response.data.category);
//           if (categoryName) {
//             const matchedCategory = response.data.category.find(
//               (category) => category.slug === categoryName
//             );
//             if (matchedCategory) {
//               setSelectedCategory(matchedCategory.name);
//               setFilteredSubcategories(matchedCategory.subcategory);
//             }
//           }
//         }
//       } catch (error) {
//         console.error("Error during API call:", error);
//       }
//     };

//     fetchCategories();
//   }, [menu, categoryName]);

//   useEffect(() => {
//     const matchedCategory = menuSlug.find(
//       (category) => category.name === selectedCategory
//     );
//     setFilteredSubcategories(
//       matchedCategory ? matchedCategory.subcategory : []
//     );
//   }, [selectedCategory, menuSlug]);

//   const applyFilter = async () => {
//     try {
//       const categoryObj = menuSlug.find((cat) => cat.name === selectedCategory);
//       const categorySlug = categoryObj?.slug || categoryName;

//       let filter = "";
//       if (selectedOption === "NewestFirst") filter = "new_first";
//       if (selectedOption === "OldFirst") filter = "old_first";
//       else if (selectedOption === "lowToHigh") filter = "price_low_to_high";
//       else if (selectedOption === "highToLow") filter = "price_high_to_low";

//       const products = await filterApi(menu, categorySlug, filter);
//       console.log("Filtered products:", products);
//       setProductData(products.data);
//     } catch (error) {
//       console.error("Error fetching filtered products:", error);
//     }
//   };

//   const handleToggleDropdown = () => {
//     setShowSortDropdown((prev) => !prev);
//   };

//   const handleSelectChange = (event) => {
//     setSelectedOption(event.target.value);
//     setShowSortDropdown(false);
//   };

//   return (
//     <>
//       <div className="mobile-filter-button-container">
//         <button className="mobile-filter-button" onClick={toggleMobileFilter}>
//           <FaFilter className="filter-icon" />
//           <span>Filters</span>
//         </button>
//       </div>
//       <div className="filter-section">
//         <div className="filter-container">
//           <h3
//             className="filter-title large1"
//             style={{ marginBottom: "20px", fontSize: "20px" }}
//           >
//             Filters
//           </h3>

//           <div className="dropdown-section">
//             <h4 className="section-title" style={{ fontSize: "16px" }}>
//               SORT BY
//             </h4>
//             <div className="dropdown-wrapper" onClick={handleToggleDropdown}>
//               <select
//                 id="dropdown"
//                 value={selectedOption}
//                 onChange={handleSelectChange}
//                 className="custom-select"
//               >
//                 <option value="" style={{ fontSize: "14px" }}>
//                   ---Select---
//                 </option>
//                 <option value="NewestFirst" style={{ fontSize: "14px" }}>
//                   Newest First
//                 </option>
//                 <option value="OldFirst" style={{ fontSize: "14px" }}>
//                   Oldest First
//                 </option>
//                 <option value="lowToHigh" style={{ fontSize: "14px" }}>
//                   Price: Low to High
//                 </option>
//                 <option value="highToLow" style={{ fontSize: "14px" }}>
//                   Price: High to Low
//                 </option>
//               </select>
//               <span className="dropdown-icon">
//                 {showSortDropdown ? <FaAngleUp /> : <FaAngleDown />}
//               </span>
//             </div>
//           </div>

//           {/* CATEGORY */}
//           <div className="category-section">
//             <div
//               className="dropdown-header"
//               onClick={() => setShowCategoryDropdown(!showCategoryDropdown)}
//             >
//               <h4 className="section-title" style={{ fontSize: "16px" }}>
//                 Category
//               </h4>
//               {showCategoryDropdown ? <FaAngleUp /> : <FaAngleDown />}
//             </div>
//             {showCategoryDropdown && (
//               <div className="category-boxes">
//                 {menuSlug.map((category) => (
//                   <button
//                     key={category.id}
//                     className={`category-box ${
//                       category.slug === categoryName ? "highlighted" : ""
//                     } ${selectedCategory === category.name ? "selected" : ""}`}
//                     onClick={() => {
//                       setSelectedCategory(category.name);
//                       setSelectedSubcategory("");
//                     }}
//                     style={{ fontSize: "14px" }}
//                   >
//                     {category.name}
//                   </button>
//                 ))}
//               </div>
//             )}
//           </div>

//           {/* SUBCATEGORY */}
//           <div className="subcategory-section">
//             <div
//               className="dropdown-header"
//               onClick={() =>
//                 setShowSubcategoryDropdown(!showSubcategoryDropdown)
//               }
//             >
//               <h4 className="section-title" style={{ fontSize: "16px" }}>
//                 Subcategory
//               </h4>
//               {showSubcategoryDropdown ? <FaAngleUp /> : <FaAngleDown />}
//             </div>
//             {showSubcategoryDropdown && (
//               <div className="subcategory-boxes">
//                 {filteredSubcategories.map((subcategory) => (
//                   <button
//                     key={subcategory.id}
//                     className={`subcategory-box ${
//                       selectedSubcategory === subcategory.name ? "selected" : ""
//                     }`}
//                     onClick={() => setSelectedSubcategory(subcategory.name)}
//                     style={{ fontSize: "14px" }}
//                   >
//                     {subcategory.name}
//                   </button>
//                 ))}
//               </div>
//             )}
//           </div>

//           <button
//             className="filter-button"
//             onClick={applyFilter}
//             style={{ fontSize: "20px" }}
//           >
//             Apply Filters
//           </button>
//         </div>
//       </div>

//       <div
//         className={`mobile-filter-overlay ${isMobileFilterOpen ? "open" : ""}`}
//         onClick={toggleMobileFilter}
//       ></div>

//       <div
//         className={`mobile-filter-panel ${isMobileFilterOpen ? "open" : ""}`}
//       >
//         <div className="mobile-filter-header">
//           <h3>Filters</h3>
//           <button className="close-filter-button" onClick={toggleMobileFilter}>
//             <FaTimes />
//           </button>
//         </div>

//         <div className="mobile-filter-content" style={{ marginTop: "13px" }}>
//           <div className="mobile-filter-section">
//             <div
//               className="mobile-filter-section-header"
//               onClick={() => setShowSortDropdown(!showSortDropdown)}
//             >
//               <h4>SORT BY</h4>
//               {showSortDropdown ? <FaAngleUp /> : <FaAngleDown />}
//             </div>
//             {showSortDropdown && (
//               <div className="mobile-filter-dropdown">
//                 <select
//                   value={selectedOption}
//                   onChange={handleSelectChange}
//                   className="mobile-custom-select"
//                 >
//                   <option value="">---Select---</option>
//                   <option value="NewestFirst">Newest First</option>
//                   <option value="OldFirst">Oldest First</option>
//                   <option value="lowToHigh">Price: Low to High</option>
//                   <option value="highToLow">Price: High to Low</option>
//                 </select>
//               </div>
//             )}
//           </div>

//           <div className="mobile-filter-section">
//             <div
//               className="mobile-filter-section-header"
//               onClick={() => setShowCategoryDropdown(!showCategoryDropdown)}
//             >
//               <h4>CATEGORY</h4>
//               {showCategoryDropdown ? <FaAngleUp /> : <FaAngleDown />}
//             </div>
//             {showCategoryDropdown && (
//               <div className="mobile-filter-options">
//                 {menuSlug.map((category) => (
//                   <button
//                     key={category.id}
//                     className={`mobile-filter-option ${
//                       category.slug === categoryName ? "highlighted" : ""
//                     } ${selectedCategory === category.name ? "selected" : ""}`}
//                     onClick={() => {
//                       setSelectedCategory(category.name);
//                       setSelectedSubcategory("");
//                     }}
//                   >
//                     {category.name}
//                   </button>
//                 ))}
//               </div>
//             )}
//           </div>

//           <div className="mobile-filter-section">
//             <div
//               className="mobile-filter-section-header"
//               onClick={() =>
//                 setShowSubcategoryDropdown(!showSubcategoryDropdown)
//               }
//             >
//               <h4>SUBCATEGORY</h4>
//               {showSubcategoryDropdown ? <FaAngleUp /> : <FaAngleDown />}
//             </div>
//             {showSubcategoryDropdown && (
//               <div className="mobile-filter-options">
//                 {filteredSubcategories.map((subcategory) => (
//                   <button
//                     key={subcategory.id}
//                     className={`mobile-filter-option ${
//                       selectedSubcategory === subcategory.name ? "selected" : ""
//                     }`}
//                     onClick={() => setSelectedSubcategory(subcategory.name)}
//                   >
//                     {subcategory.name}
//                   </button>
//                 ))}
//               </div>
//             )}
//           </div>

//           <button
//             className="mobile-apply-button"
//             onClick={() => {
//               applyFilter();
//               toggleMobileFilter();
//             }}
//           >
//             Apply Filters
//           </button>
//         </div>
//       </div>

//       <style jsx>{`
//         /* Mobile Filter Button */
//         .mobile-filter-button-container {
//           position: absolute;
//           /* top: 10px; */
//           z-index: 100;
//           /* top: 3px; */
//           right: 5px;
//           margin-top: 5px;
//         }

//         .mobile-filter-button {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 8px;
//           padding: 12px 20px;
//           background-color: #2c3e50;
//           color: white;
//           border: none;
//           border-radius: 30px;
//           font-size: 16px;
//           font-weight: 600;
//           box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
//           cursor: pointer;
//           transition: all 0.3s ease;
//         }

//         .mobile-filter-button:hover {
//           background-color: #34495e;
//           transform: translateY(-2px);
//         }

//         .filter-icon {
//           font-size: 18px;
//         }

//         /* Mobile Filter Overlay */
//         .mobile-filter-overlay {
//           position: fixed;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           background-color: rgba(0, 0, 0, 0.5);
//           z-index: 996;
//           opacity: 0;
//           visibility: hidden;
//           transition: all 0.3s ease;
//         }

//         .mobile-filter-overlay.open {
//           opacity: 1;
//           visibility: visible;
//         }

//         /* Mobile Filter Panel */
//         .mobile-filter-panel {
//           position: fixed;
//           top: 0;
//           left: -100%;
//           width: 85%;
//           max-width: 320px;
//           height: 100vh;
//           background-color: white;
//           z-index: 997;
//           overflow-y: auto;
//           transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
//           box-shadow: 2px 0 15px rgba(0, 0, 0, 0.1);
//         }

//         .mobile-filter-panel.open {
//           left: 0;
//         }

//         .mobile-filter-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           padding: 20px;
//           border-bottom: 1px solid #eee;
//         }

//         .mobile-filter-header h3 {
//           margin: 0;
//           font-size: 20px;
//           color: #333;
//         }

//         .close-filter-button {
//           background: none;
//           border: none;
//           font-size: 20px;
//           color: #666;
//           cursor: pointer;
//           transition: color 0.2s;
//         }

//         .close-filter-button:hover {
//           color: #333;
//         }

//         .mobile-filter-content {
//           padding: 0 20px 20px;
//         }

//         .mobile-filter-section {
//           margin-bottom: 20px;
//           border-bottom: 1px solid #f0f0f0;
//           padding-bottom: 15px;
//         }

//         .mobile-filter-section-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           padding: 12px 0;
//           cursor: pointer;
//         }

//         .mobile-filter-section-header h4 {
//           margin: 0;
//           font-size: 16px;
//           color: #333;
//           font-weight: 600;
//         }

//         .mobile-filter-dropdown {
//           margin-top: 10px;
//         }

//         .mobile-custom-select {
//           width: 100%;
//           padding: 10px;
//           border: 1px solid #ddd;
//           border-radius: 4px;
//           font-size: 14px;
//           background-color: #f9f9f9;
//         }

//         .mobile-filter-options {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 8px;
//           margin-top: 10px;
//         }

//         .mobile-filter-option {
//           padding: 8px 12px;
//           background-color: #f5f5f5;
//           border: none;
//           border-radius: 4px;
//           font-size: 14px;
//           cursor: pointer;
//           transition: all 0.2s;
//         }

//         .mobile-filter-option:hover {
//           background-color: #e0e0e0;
//         }

//         .mobile-filter-option.selected {
//           background-color: #2c3e50;
//           color: white;
//         }

//         .mobile-filter-option.highlighted {
//           border: 1px solid #2c3e50;
//         }

//         .mobile-apply-button {
//           width: 100%;
//           padding: 15px;
//           background-color: #2c3e50;
//           color: white;
//           border: none;
//           border-radius: 4px;
//           font-size: 16px;
//           font-weight: 600;
//           cursor: pointer;
//           margin-top: 20px;
//           transition: background-color 0.3s;
//         }

//         .mobile-apply-button:hover {
//           background-color: #34495e;
//         }

//         @media (max-width: 768px) {
//           .mobile-filter-button-container {
//             display: block;
//           }
//           .main-content {
//             margin-top: 58px;
//           }
//         }
//         @media (min-width: 768px) {
//           .mobile-filter-button-container {
//             display: none;
//           }
//         }
//       `}</style>
//     </>
//   );
// }

// export default MenFilter;
